Vue.component('category-item', {
    props: {
        id: Number,
        name: String,
        parentName: String,
        locked: Boolean,
        favourite: Boolean,
        readonly: Boolean
    },
    watch: {
        favourite: function (value) {
            this.className['-favourite'] = value;
        },
        locked: function (value) {
            this.className['-locked'] = value;
        },
        readonly: function (value) {
            this.className['-readonly'] = value;
        }
    },
    methods: {
        handleclick: function (event) {
            event.preventDefault();
            this.$emit('click', this.id);
        }
    },
    data: function () {
        return {
            className: {
                'category-item': true,
                '-favourite': this.favourite,
                '-locked': this.locked,
                '-readonly': this.readonly,
                '-is-child': this.parentName.length != 0
            },
            fullName: this.parentName + ' ' + this.name
        }
    },
    template: '<div :class="className" :title="name" @click="handleclick" @keyup.enter="handleclick" tabindex="0">'
    + '<span v-if="parentName">{{parentName}} / </span>'
    + '<strong>{{name}}</strong>'
    + '</div>'
});
